import { jsxs as s, jsx as h } from "react/jsx-runtime";
import { E as d, S as f } from "./icons.types-0722eef5.js";
function F({ title: i, titleId: r, size: l, width: a, height: n, extended: c = !1, ...t }) {
  const o = c ? d : f, e = l ? o[l] : a || o[c ? "s" : "l"], v = l ? o[l] : n || o[c ? "s" : "l"];
  return /* @__PURE__ */ s(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: e,
      height: v,
      "aria-labelledby": r,
      ...t,
      children: [
        i ? /* @__PURE__ */ h("title", { id: r, children: i }) : null,
        /* @__PURE__ */ s("g", { clipPath: "url(#Facebook_svg__a)", children: [
          /* @__PURE__ */ h(
            "path",
            {
              fill: "currentColor",
              d: "M72 36C72 16.118 55.882 0 36 0S0 16.118 0 36c0 17.969 13.165 32.862 30.375 35.563V46.406h-9.14V36h9.14v-7.931c0-9.023 5.375-14.006 13.598-14.006 3.938 0 8.058.703 8.058.703v8.859h-4.54c-4.471 0-5.866 2.775-5.866 5.622V36h9.984l-1.596 10.406h-8.388v25.157C58.835 68.862 72 53.968 72 36Z"
            }
          ),
          /* @__PURE__ */ h(
            "path",
            {
              fill: "#FFF",
              d: "M50.013 46.406 51.61 36h-9.984v-6.753c0-2.847 1.395-5.622 5.867-5.622h4.54v-8.86s-4.12-.703-8.06-.703c-8.222 0-13.597 4.984-13.597 14.007V36h-9.14v10.406h9.14v25.157C32.208 71.85 34.086 72 36 72c1.914 0 3.792-.15 5.625-.438V46.407h8.388Z"
            }
          )
        ] }),
        /* @__PURE__ */ h("defs", { children: /* @__PURE__ */ h("clipPath", { id: "Facebook_svg__a", children: /* @__PURE__ */ h(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  F as Facebook
};
